import TemplateContents from './TemplateContents';
import {gsap} from "gsap";

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();


    // APIが読み込まれた
    window.onYouTubeIframeAPIReady = () => {
      const videoId = 'eKz4qCU6CzE';
      this.youtubeVideo1 = new YT.Player('player', {
        videoId: videoId,  // 再生したい動画のID
        width: 640,
        height: 360,
        playerVars: {
          autoplay: 1,          // 自動再生
          mute: 1,              // ミュート（autoplayには必須）
          controls: 0,          // コントロールバー非表示
          loop: 1,              // ループ再生
          playlist: videoId,    // 単一動画をループさせる場合に必須
          modestbranding: 1,    // YouTubeロゴ最小化
          rel: 0,               // 関連動画を制限
          showinfo: 0,          // タイトル非表示（非推奨だが一部有効）
          fs: 0,                // フルスクリーンボタン非表示
          cc_load_policy: 0,    // 字幕非表示
          iv_load_policy: 3,    // アノテーション非表示
          disablekb: 1,         // キーボード操作無効
          playsinline: 1        // iOS向けインライン再生
        },
      });


      this.youtubeVideo2 = new YT.Player('player2', {
        videoId: 'eKz4qCU6CzE',  // 再生したい動画のID
        width: 640,
        height: 360,
        playerVars: {
          autoplay: 0,          // 自動再生
          mute: 0,              // ミュート（autoplayには必須）
          controls: 1,          // コントロールバー非表示
          loop: 0,              // ループ再生
          modestbranding: 1,    // YouTubeロゴ最小化
          rel: 0,               // 関連動画を制限
          showinfo: 0,          // タイトル非表示（非推奨だが一部有効）
          fs: 0,                // フルスクリーンボタン非表示
          cc_load_policy: 0,    // 字幕非表示
          iv_load_policy: 3,    // アノテーション非表示
          disablekb: 1,         // キーボード操作無効
          playsinline: 0        // iOS向けインライン再生
        },
      });
    }

    let tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    document.head.appendChild(tag);
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  setVars() {
    super.setVars();

    this.isHover = false;
    this.mouse = { x: 0, y: 0 };
    this.easeMouse = { x: 0, y: 0 };

  }

  setDom() {
    super.setDom();
    this.section2 = document.querySelector('main.top .section2');
    this.overlay = document.querySelector('main.top .section2 .video .overlay');
    this.playIcon = document.querySelector('main.top .play_icon');
    this.modal = document.querySelector('main.top .brand_movie_modal');
    this.modalCloseBtn = document.querySelector('main.top .brand_movie_modal .brand_movie_ui .c_close_btn');
    this.modalBG = document.querySelector('main.top .brand_movie_modal .brand_movie_bg');
    if (this.pack.ua.isiOS && this.section2) {
      this.section2.classList.add('is-ios');
    }
  }

  initEvents() {
    super.initEvents();

    this.section2.addEventListener('mouseover', (event) => {
      this.isHover = true;
      this.playIcon.classList.add('show');
      this.overlay.classList.add('show');
    });

    this.section2.addEventListener('mouseenter', (event) => {
      this.isHover = true;
      this.playIcon.classList.add('show');
      this.overlay.classList.add('show');
    });

    this.section2.addEventListener('mouseout', (event) => {
      this.isHover = false;
      this.playIcon.classList.remove('show');
      this.overlay.classList.remove('show');
    });

    this.section2.addEventListener('mouseleave', (event) => {
      this.isHover = false;
      this.playIcon.classList.remove('show');
      this.overlay.classList.remove('show');
    });

    this.section2.addEventListener('click', this.openModal.bind(this));
    this.modalCloseBtn.addEventListener('click', this.closeModal.bind(this));
    this.modalBG.addEventListener('click', this.closeModal.bind(this));

    document.addEventListener('mousemove', (event) => {
      this.mouse.x = event.clientX;
      this.mouse.y = event.clientY;
    });

    this.pack.applyIconHoverEffect(this.modalCloseBtn, this.modalCloseBtn);
  }

  openModal(event){
    this.modal.classList.add('active');
    requestAnimationFrame(()=>{
      this.modal.classList.add('open');
    });

    this.pack.common.lockScroll = true;
    if (this.sw < this.pack.BP) document.documentElement.classList.add('lock');
  }

  closeModal(event){
    if (this.youtubeVideo2 && typeof this.youtubeVideo2.getPlayerState === 'function') {
      if (this.youtubeVideo2.getPlayerState() === YT.PlayerState.PLAYING) {
        this.youtubeVideo2.pauseVideo();
      }
    }
    this.modal.classList.remove('open');
    gsap.delayedCall(.5, ()=>{
      this.modal.classList.remove('active');
      this.pack.common.lockScroll = false;
      if (this.sw < this.pack.BP) document.documentElement.classList.remove('lock');
    });
  }

  start() {
    this.initObserver();
  }

  initObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (this.youtubeVideo1 && typeof this.youtubeVideo1.playVideo === 'function') {
            this.youtubeVideo1.playVideo();
          }
        } else {
          if (this.youtubeVideo1 && typeof this.youtubeVideo1.pauseVideo === 'function') {
            this.youtubeVideo1.pauseVideo();
          }
        }
      });
    }, { rootMargin: '0px' });
    this.observer.observe(this.section2);
  }

  scrollHandler() {

  }

  enterframe() {
    this.easeMouse.x += (this.mouse.x - this.easeMouse.x ) / 10;
    this.easeMouse.y += (this.mouse.y - this.easeMouse.y ) / 10;

    if(this.isHover){
      let x = this.easeMouse.x;
      let y = this.easeMouse.y;
      this.playIcon.style.transform = `translate3d(${x}px,${y}px,0)`;
    }
  }

  enterframeThinOut() {

  }

  executeResize() {
    super.executeResize();
  }
}
